'use client';

import { AuthProvider } from '@/contexts/AuthContext';
import { Suspense } from 'react';
import GoogleAnalytics from '@/components/GoogleAnalytics';

export default function ClientProviders({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      <Suspense fallback={null}>
        <GoogleAnalytics />
      </Suspense>
      {children}
    </AuthProvider>
  );
}